import { recipe } from "@vanilla-extract/recipes";

import { theme } from "../../../theme/css/theme.css";

export const stepChipStyle = recipe({
  base: {
    borderRadius: theme.borderRadiuses.s,
  },
  variants: {
    status: {
      pending: {
        color: theme.colors.inputBorderFocus,
      },
      "in-progress": {
        color: theme.colors.primary,
      },
      completed: {
        color: theme.colors.success,
      },
      error: {
        color: theme.colors.error,
      },
    },
  },
  defaultVariants: {
    status: "pending",
  },
});
